import hasSupportedPaymentMethods from "../web/components/landingPage/pages/Plans/utils/hasSupportedPaymentMethods";
import { useEffect } from "react";

const useSetDefaultPaymentMethod = ({
  setSelectedPaymentMethod,
  availablePaymentMethods,
  currentCurrencyOfferByPeriod,
  supportedPaymentMethods,
  period
}) => {
  const paymentMethods = currentCurrencyOfferByPeriod?.payment_methods ?? [];
  const hasSupportedPaymentMethod = hasSupportedPaymentMethods({
    paymentMethods,
    supportedPaymentMethods
  });

  useEffect(() => {
    if (!hasSupportedPaymentMethod) {
      return;
    }

    const defaultPaymentMethod = availablePaymentMethods.find(
      method => method?.isDefault === true
    );

    setSelectedPaymentMethod(
      defaultPaymentMethod ?? availablePaymentMethods[0]
    );
  }, [period, currentCurrencyOfferByPeriod]);
};

export default useSetDefaultPaymentMethod;
